import { Component, h, State } from '@stencil/core';
import { signaler } from '../../utils/signaler';

@Component({
  tag: 'ci-design-lab',
  styleUrl: 'ci-design-lab.scss',
})
export class ciDesignLab {
  @State() apparelHeaderTest: boolean;

  async componentWillLoad() {
    this.apparelHeaderTest = (await signaler.featureFlag('apparel_header_v4')) === 'test';
  }
  render() {
    return (
      <div class="ciDesign">
        {this.apparelHeaderTest
          ? [
          <ci-design-lab-test></ci-design-lab-test>
          ]
        : [
          <ci-design-lab-control></ci-design-lab-control>
        ]}
      </div>
    );
  }
}
